import React from 'react';
import PropTypes from 'prop-types';
import { ProgressSurveyQuestion, SFEntityID } from 'utils/types';
import css from './Comment.css';
import { Form } from 'semantic-ui-react';
import TextareaAutosize from 'react-textarea-autosize';

export default class Comment extends React.Component {

  getDefaultValue() {
    const { includeDefaultComments, defaultRaiseComments } = this.props.question;
    return includeDefaultComments && defaultRaiseComments ? defaultRaiseComments : "";
  }

  getValue(questionId) {
    const defaultValue = this.getDefaultValue();
    if ( !this.props.answers ) return defaultValue;
    const answer = this.props.answers.find(({id}) => id === questionId);
    if ( !answer ) return defaultValue;
    return answer.comment;
  }

  get hasError() {
    // If nothing checked, can't be any error
    if ( !this.props.answers ) return false;

    const invalidAnswers = this.props.answers
      .filter(answer => this.props.question.id === answer.id)
      .filter(answer => answer.shouldValidate && !answer.isValid);

    return invalidAnswers.length > 0;
  }

  get class() {
    return `${css['comment-textarea']} ${this.hasError ? css['comment-error'] : ""}`;
  }

  get id() {
    return `${this.props.studentId}-${this.props.question.name}`;
  }

  get label() {
    return this.props.isMobile 
      ? null 
      : <label htmlFor={this.id}>{this.props.question.name}</label>;
  }

  render() {
    const { question, onAnswerChanged, studentId } = this.props;
    return (
      <Form key={question.id}>
        {this.label}
        <TextareaAutosize
          id={this.id}
          placeholder={question.commentRequired ? "Comment required" : "Comment is optional"}
          className={this.class}
          rows={2}
          aria-label={`Enter feedback for ${question.name} for ${this.props.studentName}`}
          onChange={e => onAnswerChanged(studentId, question.id, e.target.value)}
          onBlur={() => onAnswerChanged(studentId, question.id, this.getValue(question.id), true)}
          value={this.getValue(question.id)}
        />
      </Form>
    );
  }
}

Comment.propTypes = {
  studentId: SFEntityID.isRequired,
  studentName: PropTypes.string.isRequired,
  onAnswerChanged: PropTypes.func.isRequired,
  answers: PropTypes.array,
  isMobile: PropTypes.bool.isRequired,
  question: ProgressSurveyQuestion.isRequired
};
